module.exports = __webpack_public_path__ + "img/68eca81af6c24dd9ba0a601c5c60f709-1440.6eff93ae.jpg";